<template>
  <v-btn flat dark @click="logoutAndRedirect">
    <v-icon>lock_open</v-icon>
    &nbsp;Sign out<span v-if="currentUser"
      >: {{ currentUser.FirstName }} {{ currentUser.LastName }}</span
    >
  </v-btn>
</template>
<script>
import { authMethods, authComputed } from '@state/helpers'
export default {
  //model: {
  //  prop: ''
  //},
  props: {},
  components: {},
  filters: {},
  data() {
    return {}
  },
  created() {},
  computed: {
    ...authComputed,
  },
  methods: {
    ...authMethods,
    logoutAndRedirect() {
      this.$router.push({ name: 'home' })
      this.logOut()
    },
  },
  watch: {},
}
</script>
<style scoped></style>
